<div class="header-wrapper" data-test-tag="header-banner">
    <ev-page-top-menu></ev-page-top-menu>

    <div class="bottom-layer">
        <div class="left-side">
            <div class="title">
                <p class="green-text">ev</p>
                <p>Info</p>
            </div>
        </div>
        <div class="right-side">
            @if (!expand()) {
                <a class="search-icon" (click)="openSearch()"></a>
            }
        </div>
    </div>

    @if (expand()) {
        <div
            class="multi-search-wrapper"
            [class.multisearch]="searchMode === SearchModeEnum.MULTISEARCH"
            [class.owner]="searchMode === SearchModeEnum.OWNERSEARCH"
            [class.customercheck]="searchMode === SearchModeEnum.CUSTOMERCHECK"
            [class.appraisal]="searchMode === SearchModeEnum.APPRAISALSEARCH"
        >
            <ev-multi-search (close)="localExpandState.set(false)" (searchMode)="searchChange($event)"></ev-multi-search>
        </div>
        <div class="search-guide-wrapper">
            <search-guide [searchMode]="searchMode"></search-guide>
        </div>
    }
</div>
